import { Card } from "solid-bootstrap";
import { PatcherSet } from "../patcher";
import { Show } from "solid-js";

export default function ({ patcher }: { patcher: PatcherSet }) {
  const [visible] = patcher.visible;
  const [errorLog] = patcher.errorLog;
  const [validated] = patcher.validated;
  const [dllFile] = patcher.dllFile;

  return (
    <Show when={visible()}>
      <Card class="mt-3">
        <div class="card-body m-2">
          <h5 class="card-title">{patcher.filename} ({patcher.name})</h5>
          <Show when={validated()}>
            <div class="success">文件加载成功！</div>
          </Show>
          <Show when={!validated()}>
            <hr />
            <pre class="error" innerHTML={errorLog()}></pre>
            <hr />
          </Show>
          {patcher.mods.map(v => v.ui())}
          <button class="btn btn-success mt-4 w-100" disabled={!dllFile()} onclick={() => patcher.exportPatches()}>导出 patches.json</button>
          <button class="btn btn-primary mt-2 w-100" disabled={!dllFile()} onclick={() => patcher.saveDll()}>保存修补后的文件</button>
        </div>
      </Card>
    </Show>
  );
}
